import Translate from '~/client/shared/i18n/Translate';
import kformatter from '~/shared/utils/number/kformatter';
import Loader from '@/external/components/Loader';

type Props = { total?: number };

const ToggleCaption: FC<Props> = ({ total = -1 }) => {
  if (total < 0) {
    return <Loader size="xs" color="border-trunks" />;
  }
  return (
    <span>
      <span>{kformatter(total)}</span> <Translate id="general.clapps" />
    </span>
  );
};

export default ToggleCaption;
